import { Modal } from 'bootstrap';
import Global from '../common/global';
import { ButtonHelper } from './../common/buttonHelper';
import { initSearchBarFields } from '../common/searchBarFields';
import { initTransferCalendar } from '../common/calendar';

export class TransferHelper {
    static getAvailableTransferRoomsUrl(hotelId: string, pageRef: string): string {
        const roomInfoString = ($("#SearchBarForm_RoomInfoString").val() as string) || '';
        const rateCodeSlug = ($("#SearchBarForm_RateCodeSlug").val() as string) || '';
        const arrivalDateRestriction = ($("#SearchBarForm_ArrivalDateRestriction").val() as string) || '';

        const startDate = parseInt(($("#SearchBarForm_BreakArrivalDateCounter").val() as string) || '0', 10);
        const endDate = parseInt(($("#SearchBarForm_BreakDepartureDateCounter").val() as string) || '0', 10);
        const searchPageId = ($("#SearchBarForm_SearchPageId").val() as string) || '';
        const numberOfNights = endDate - startDate;

        let flexiUrl = `/Hotel/AvailableTransferRooms?hotelId=${hotelId}&startDateCounter=${startDate}&numberOfNights=${numberOfNights}&roomInfoString=${roomInfoString}&arrivalDateRestriction=${arrivalDateRestriction}&pageRef=${pageRef}&so=${searchPageId}`;

        if (rateCodeSlug) {
            flexiUrl += `&rateCodeSlug=${rateCodeSlug}`;
        }

        return flexiUrl;
    }

    static initCustomerTransferBooking(): void {
        $('.btn-transfer-booking').on('click', function (e) {
            e.preventDefault();

            const bookingId = $(this).data('booking-id');

            $.ajax({
                type: 'POST',
                url: '/Booking/RetrieveToTransfer',
                data: {
                    '__RequestVerificationToken': Global.getAntiForgeryToken(),
                    'bookingId': bookingId
                },
                success: (data: any) => {
                    const modalElement = document.getElementById('transferBookingModal');
                    if (modalElement) {
                        const modalContent = modalElement.querySelector('.modal-content');
                        if (modalContent) {
                            modalContent.innerHTML = data;
                        }

                        // Assuming Bootstrap 5 is imported and available globally
                        const modal = new Modal(modalElement);
                        modal.show();

                        ButtonHelper.resetSpinnerButtons();
                    }
                    initSearchBarFields({ desktopBreakpoint: 992, isTransfer: true });
                    initTransferCalendar(true);
                },
                error: (xhr: JQuery.jqXHR, status: JQuery.Ajax.ErrorTextStatus) => {
                    let errorMessage = '';
                    if (xhr.responseJSON?.publicMessage) {
                        errorMessage += xhr.responseJSON.publicMessage;
                    }
                    if (xhr.responseJSON?.privateMessage) {
                        errorMessage += ' ' + xhr.responseJSON.publicMessage;
                    }
                }
            });
        });

        $(document).on('click', '#btnSubmitCustomerTransferSearchModal', (e: JQuery.ClickEvent) => {
            e.preventDefault();

            const hotelId = ($("#ProviderId").val() as string) || '';
            const bookingId = ($("#BookingId").val() as string) || '';

            $.ajax({
                type: 'GET',
                url: `/Transfer/CustomerTransferMode?bookingId=${bookingId}`,
                success: (data: any) => {
                    var roomsUrl = this.getAvailableTransferRoomsUrl(hotelId, "ManageBooking")

                    if (data) {
                        $.ajax({
                            type: 'GET',
                            url: roomsUrl,
                            success: (data: any) => {
                                $(".available-transfer-rooms").html(data);
                            },
                            error: (xhr: JQuery.jqXHR, status: string) => {
                                console.error(xhr, status);

                            }
                        });

                        ButtonHelper.resetSpinnerButtons();
                    }
                },
                error: (xhr: JQuery.jqXHR, status: string) => {
                    console.error(xhr, status);
                }
            });
        });
    }

    static initCallCentreTransferMode(): void {
        $('.transfer-mode-container').on('click', (e) => {
            e.preventDefault();
            $('#transferBookingModal').modal('show');
        });
    }

    static initAddToTransferBasket() {
        document.addEventListener('click', (event) => {
            const target = event.target as HTMLElement;
            if (!target || !target.classList.contains('btn-add-to-transfer-basket')) return;
            // First check currency is OK
            const basketCurrency = (document.getElementById('TransferBasketCurrency') as HTMLInputElement)?.value || '';
            let isValidCurrency = false;

            if (basketCurrency === '') {
                isValidCurrency = true;
            } else {
                const itemCurrency = target.dataset['currencyId'];
                if (basketCurrency === itemCurrency) {
                    isValidCurrency = true;
                }
            }

            const transferOldBookingId = (document.getElementById('TransferOldBookingId') as HTMLInputElement)?.value || '';
            const transferSessionId = (document.getElementById('TransferSessionId') as HTMLInputElement)?.value || '';
            const providerOccupancyTypeId = target.dataset['providerOccupancyTypeId'];

            // Hide any previous error messages
            const errorModal = document.getElementById('errorModal');
            if (errorModal) {
                errorModal.querySelectorAll('.errorText').forEach(el => el.classList.add('hidden'));
            }

            // Show appropriate error message
            if (!isValidCurrency && errorModal) {
                const invalidCurrencyMessage = errorModal.querySelector('#invalidCurrencyMessage');
                if (invalidCurrencyMessage) invalidCurrencyMessage.classList.remove('hidden');
                ($(errorModal) as any).modal('show'); // Using jQuery for Bootstrap modal
            } else {
                // All OK so add the room(s) to the basket
                const startDate = (document.getElementById('SearchBarForm_ArrivalDateCounter') as HTMLInputElement)?.value || '';
                const numberOfNights = (document.getElementById('SearchBarForm_NumberOfNights') as HTMLInputElement)?.value || '';
                const roomInfoString = (document.getElementById('SearchBarForm_RoomInfoString') as HTMLInputElement)?.value || '';

                const addToBasketUrl = `/Transfer/GetTransferDetails?searchKey=${encodeURIComponent(transferSessionId)}&oldBookingId=${encodeURIComponent(transferOldBookingId)}&providerOccupancyTypeId=${encodeURIComponent(providerOccupancyTypeId || '')}&startDate=${encodeURIComponent(startDate)}&numberOfNights=${encodeURIComponent(numberOfNights)}&roomInfoString=${encodeURIComponent(roomInfoString)}`;

                window.location.href = addToBasketUrl;
            }
        });
    }
}